import L from 'leaflet'
import { Marker, MarkerProps } from 'react-leaflet'
import useStyles from '../../styles'

const ClientMarker = ({ children, color, ...rest }: MarkerProps & { color: string }) => {
  const classes = useStyles()

  const customIcon = L.divIcon({
    className: 'custom-div-icon',
    html: `<div class=${classes.userIcon} style="background: ${color};" />`,
    iconAnchor: [1.75, 12],
  })

  return (
    <Marker {...rest} icon={customIcon}>
      {children}
    </Marker>
  )
}

export default ClientMarker
